import pluralize from 'pluralize';
import { kebabCase } from 'lodash';
import { entityTypeNameFor } from './entity-type-name-for';
export var entityTypeNamePluralSlug = function (entity) {
  return kebabCase(pluralize(entityTypeNameFor(entity)));
};